import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { FetchSportConfig, SetCurrentSport } from '@oneapp/main/core/sport/sport.actions';
import { DEFAULT_SPORT_FOR_APP } from '@oneapp/main/core/sport/sport.models';
import {
    isEmpty as _isEmpty,
    intersection as _intersection,
    every as _every,
    uniq as _uniq
} from 'lodash';
import { map, Observable, of, zip } from 'rxjs';
import { AuthState } from './auth/auth.state';
import { getAvailableSportsBasedOnApis } from '@oneapp/main/core/sport/sport.utils';
import { Sport } from 'environments/environment';

@Injectable()
/**
 * Sets the current sport and fetches the sport config because those state properties are needed for certain
 * things before other parts of the app are ready (i.e. route guards)
 */
export class SportInitializer {
    constructor(
        private _store: Store
    ) { }

    /* APP_INITILIZER only supports Promise for now... there is a feature request opened on github
     * https://github.com/angular/angular/issues/15088
     */
    public initializeSport(): Observable<boolean> {
        const userBySport = this._store.selectSnapshot(AuthState.userBySport);
        if (!_every(userBySport)) {
            return of(true);
        }
        // split the URL into it's parts, we have to use the URL because the router is not available yet
        const urlParts = window.location.href.split('/');
        // find the sport in the url
        const sportFromUrl = _uniq(
            _intersection(urlParts, getAvailableSportsBasedOnApis())
        );

        // it is possible the sport is not in the URL so if it is not we set the sport to the default sport
        const sportForApp = !_isEmpty(sportFromUrl) ? sportFromUrl[0] as Sport : DEFAULT_SPORT_FOR_APP;

        // dispatch the actions to set the current sport and to fetch the sport config
        return zip(
            this._store.dispatch(new FetchSportConfig(sportForApp)),
            this._store.dispatch(new SetCurrentSport(sportForApp))
        ).pipe(map(values => true));
    }
}
